// Game-mode model (§5). Modes are hosted inside the Forge (except Lab which is a
// separate 4-slot workbench) — a target-driven design ported from the prototype.
import { GameMode } from "../App";

export type ModeKind = "free" | "time" | "daily" | "gauntlet" | "battle" | "lab";

export const TIME_LIMIT_SEC = 90;

// Gauntlet: 10 rising target elements; each cleared level unlocks the next.
export const GAUNTLET_TARGETS = [
  "steam", "clay", "sand", "brick", "forest",
  "life_form", "steel", "diamond", "computer", "star",
];

// Daily puzzle: same target for everyone on a given calendar day.
const DAILY_POOL = ["aurora", "rainbow", "volcano", "diamond", "phoenix", "forest", "glass", "steel", "crystal", "lightning"];

/** Deterministic daily target based on day-of-year (everyone gets the same one). */
export const dailyTarget = (now = new Date()): string => {
  const start = new Date(now.getFullYear(), 0, 0);
  const doy = Math.floor((now.getTime() - start.getTime()) / 86400000);
  return DAILY_POOL[doy % DAILY_POOL.length];
};

export const gauntletLevelForTarget = (id: string): number => GAUNTLET_TARGETS.indexOf(id);

/** The next gauntlet target to attempt given how many levels are cleared. */
export const nextGauntletTarget = (cleared: number): string =>
  GAUNTLET_TARGETS[Math.min(cleared, GAUNTLET_TARGETS.length - 1)];

/** Map the GameMode enum label (from Home navigation) to an internal mode kind. */
export const kindFromLabel = (label?: string): ModeKind => {
  switch (label) {
    case GameMode.TIME_ATTACK:
      return "time";
    case GameMode.DAILY_PUZZLE:
      return "daily";
    case GameMode.GAUNTLET:
      return "gauntlet";
    case GameMode.BATTLE_ARENA:
      return "battle";
    case GameMode.LAB_MODE:
      return "lab";
    case GameMode.FREE_FORGE:
    default:
      return "free";
  }
};

export const MODE_META: Record<
  ModeKind,
  { label: string; accent: string }
> = {
  free: { label: "Free Forge", accent: "var(--accent-text)" },
  time: { label: "Time Attack", accent: "#60A5FA" },
  daily: { label: "Daily Puzzle", accent: "#F5B740" },
  gauntlet: { label: "Gauntlet", accent: "#34D399" },
  battle: { label: "Battle Arena", accent: "#F472B6" },
  lab: { label: "Combination Lab", accent: "#B48CFF" },
};
